export enum MoreLessPosition {
  Infobank,
  SprawdzBank,
  AgroKalk,
  Kalkulator,
  Alert,
  Benchmark,
  Exact,
  News
}
